export const POSITION_PER_PAGE_MAX = 5;
